import { PermissionType } from "shared/constants/permission-type";

export const getPermissionName = (permission, task, redoTask = "") => {
    switch (permission) {
        case PermissionType.CREATE_NOTE:
            return `create:${task}note`;
        case PermissionType.COMPLETE_TASK:
            return `complete:${task}task`;
        case PermissionType.REJECT_TASK:
            return `reject:${task}task`;
        case PermissionType.REJECT_BULK_FQA_TASKS:
            return "reject:FinalQaBulkReject";
        case PermissionType.EDIT_SOURCE:
            return `complete:editingsourceselections`;
        case PermissionType.EDIT_DIGITAL_LITE_STATUS:
            return `edit:digitallitestatus`;
        case PermissionType.UPLOAD_SHOT:
            return `upload:${task}uneditedshot`;
        case PermissionType.DELETE_SHOT:
            return `delete:${task}uneditedshot`;
        case PermissionType.UPLOAD_IMAGE:
            return `upload:${task}editedshot`;
        case PermissionType.DOWNLOAD_IMAGE:
            return `download:${task}shot`;
        case PermissionType.UPLOAD_BULK:
            return `upload:${task}bulkupload`;
        case PermissionType.DOWNLOAD_BULK:
            return `download:${task}bulk`;
        case PermissionType.PACKAGE_TYPE:
            return `select:${task}packagetype`;
        case PermissionType.SKIP_EDITING:
            return `update:imagetoskipeditingon${task}`;
        case PermissionType.REDO_TASK:
            const profilingOverride = redoTask === "scheduling" ? "profiling" : redoTask;

            return `redo:${profilingOverride}from${task}`;
        case PermissionType.MEASURE_PEGHOLES:
            return `create:pegholesfrom${task}`;
        case PermissionType.ADD_ATTRIBUTE:
            return `add:productattributefrom${task}`;
        case PermissionType.EDIT_ATTRIBUTE:
            return `edit:productattributefrom${task}`;
        case PermissionType.DELETE_ATTRIBUTE:
            const fqaOverride = task === "finalqa" ? "fqa" : task;

            return `delete:${fqaOverride}attribute`;
        case PermissionType.COMPLETE_BULK_UPLOAD_IMAGES_FOR_MULTIPLE_UPCS:
            return `complete:bulkuploadimagesformultipleupcs`;
        default:
            return null;
    }
};
